import { Component, Input } from '@angular/core';
import {ChipModule} from 'primeng/chip';
import {CommonModule} from '@angular/common';


@Component({
  selector: 'app-wordpress-check',
  standalone: true,
  imports: [CommonModule, ChipModule],
  templateUrl: './wordpress-check.component.html',
  styleUrl: './wordpress-check.component.css'
})
export class WordpressCheckComponent {
  @Input() label: string = '';
  @Input() checked:string = 'false';

  toBoolean(value: string | boolean) {
    return ( value === 'true' || value === true );
  }
}
